import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyValueComponent } from './key-value/key-value.component';
import { KeyValueAddComponent } from './key-value-add/key-value-add.component';
import { KeyValueTableComponent } from './key-value-table/key-value-table.component';
import { MbComponentsModule } from '../mb-components/mb-components.module';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    KeyValueComponent,
    KeyValueAddComponent,
    KeyValueTableComponent
  ],
  imports: [
    CommonModule,
    MbComponentsModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    KeyValueComponent
  ]
})
export class KeyValueModule { }
